// extracted by mini-css-extract-plugin
module.exports = {"jobItem":"Job_jobItem__fzpDT","jobDetailTitle":"Job_jobDetailTitle__1NZ8_","jobButton":"Job_jobButton__3SSWO","jobLine":"Job_jobLine__1Z6iP"};